import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import vuetify from './plugins/vuetify';
import { performancePlugin } from './plugins/performance';
import i18n from './plugins/i18n';
import { useProjectConfigStore } from '@/stores/projectConfig';

const app = createApp(App);

app.use(router);
const pinia = createPinia();
app.use(pinia);
app.use(vuetify);
// Start loading project config (logo, palette) in parallel with app init
useProjectConfigStore(pinia).load();
app.use(performancePlugin);
app.use(i18n);

app.mount('#app');
